import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { PaartnerLogo } from "./assets";
import * as PRTNR from "./prtnr";
import OtpInput from "./prtnr/ui/OtpInput";
import { confirmLogin, otpAuthentication } from "./redux/slices/LoginThunks";

export default function AdminOTPAuthentication() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const local_token = localStorage.getItem("token");
  const location = useLocation();
  const { email, password } = location.state;
  const [submitted, setSubmitted] = useState(false);
  const { status, error, user, token } = useSelector((state) => state.login);
  const local_user = JSON.parse(localStorage.getItem("user"));
  const [otp, setOtp] = useState("");
  const [resendDisabled, setResendDisabled] = useState(false);
  const [timer, setTimer] = useState(0);

  const handler = async () => {
    setSubmitted(true);
    const data = {
      userId: local_user?._id,
      code: otp,
    };
    await dispatch(otpAuthentication(data));
    setSubmitted(false);
  };

  const handleResend = async () => {
    if (resendDisabled) return; // Prevent multiple clicks

    setResendDisabled(true);
    setTimer(30); // Start 30-second cooldown

    try {
      await dispatch(confirmLogin({ email, password }));
      toast.success("Reset Token Sent");
    } catch (e) {
      console.log(e, "error");
    }

    // Countdown timer
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setResendDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    if (user || local_token) {
      navigate("/adminpendingreferrals");
    }
  }, [user, navigate, local_token]);

  return (
    <RootWrapperHome>
      <Header>
        <HeaderWrapper>
          <Left>
            <Logo
              onClick={() => navigate("/")}
              src={PaartnerLogo}
              alt="Paartner Logo"
            />
          </Left>
        </HeaderWrapper>
      </Header>
      <Section>
        <Wrapper>
          <SignupSignin>
            <ContentBlock1>
              <Content>
                <EarningCashForMakingReferralsIsEasierThanEver>
                  OTP Authentication
                </EarningCashForMakingReferralsIsEasierThanEver>
                <DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed>
                  Enter the OTP we sent to your email.
                </DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed>
              </Content>
            </ContentBlock1>
            <Frame60>
              <Frame58>
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  length={6}
                  required
                  error={false}
                  errorMessage="Please enter a valid 6-digit code"
                />

                <Frame59>
                  <div
                    style={{ justifyContent: "center", alignItems: "center" }}
                    onClick={() => {
                      handler();
                    }}
                  >
                    <PRTNR.Button variant="black" width={"320px"}>
                      Login
                    </PRTNR.Button>
                  </div>
                </Frame59>
                {error && (
                  <IncorrectText>Otp is incorrect or expired.</IncorrectText>
                )}

                <PRTNR.Button variant="gray-light">
                  <span style={{ fontWeight: 500, fontSize: "16px" }}>
                    Didn't receive an OTP?{" "}
                    <span
                      onClick={!resendDisabled ? handleResend : undefined}
                      style={{
                        color: "#6162C5",
                        fontWeight: 600,
                        cursor: resendDisabled ? "not-allowed" : "pointer",
                        pointerEvents: resendDisabled ? "none" : "auto",
                      }}
                    >
                      {resendDisabled ? `Resend in ${timer}s` : "Resend"}
                    </span>
                  </span>
                </PRTNR.Button>
              </Frame58>
              <Hint>
                Hint: you might need to check your spam or junk folders if it's
                not in your inbox.
              </Hint>
            </Frame60>
          </SignupSignin>
        </Wrapper>
      </Section>
      <Footer>
        <Section_0001>
          <Section_0002>
            <Wrapper_0001>
              <Frame38>
                <_2025PaartnerLimitedAllRightsReserved>
                  © 2025 Paartner Limited. All Rights Reserved
                </_2025PaartnerLimitedAllRightsReserved>
              </Frame38>
            </Wrapper_0001>
          </Section_0002>
        </Section_0001>
      </Footer>
    </RootWrapperHome>
  );
}

const RootWrapperHome = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Header = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
const Hint = styled.div`
  font-family: Montserrat;
  font-weight: 500;
  font-size: 16px;
  line-height: 160%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: var(--Color-Text-Gray, #64748b);
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: 1;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 24px 16px;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Logo = styled.img`
  width: 165px;
  height: 24px;
  position: relative;
`;

const Section = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: 1;
  gap: 8px;
  align-self: stretch;
  height: 882px;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 60px;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  box-sizing: border-box;
`;

const SignupSignin = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const ContentBlock1 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 560px;
  box-sizing: border-box;
`;

const EarningCashForMakingReferralsIsEasierThanEver = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 48px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -1px;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 24px;
  border: solid 1px rgba(136, 136, 136, 0.1);
  border-radius: 32px;
  width: 560px;
  background: rgb(226, 232, 240);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 32px;
`;
const Frame60 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  width: 560px;
`;

const Frame59 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  width: 100%;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Section_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Section_0002 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Wrapper_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame38 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _2025PaartnerLimitedAllRightsReserved = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const IncorrectText = styled.span`
  color: red;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;
